/**
 * Store sub context for auth data
 */
import { AuthUserProps } from '../../config/interfaces';

const AuthContext = {
  authorizedUser: {} as AuthUserProps,
  sessionId: '',
  user34: '',
  authRoles: [] as string[],
  employeesDelegatedTo: []
};

export default AuthContext;
